import { render, staticRenderFns } from "./39bzkxxyjbg.vue?vue&type=template&id=7bb28fdc&"
import script from "./39bzkxxyjbg.vue?vue&type=script&lang=js&"
export * from "./39bzkxxyjbg.vue?vue&type=script&lang=js&"
import style0 from "./39bzkxxyjbg.vue?vue&type=style&index=0&id=7bb28fdc&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports